"use strict";

var _typeof = require("@babel/runtime-corejs3/helpers/typeof");

var _Reflect$construct = require("@babel/runtime-corejs3/core-js-stable/reflect/construct");

var _Object$keys = require("@babel/runtime-corejs3/core-js-stable/object/keys");

var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols");

var _filterInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/filter");

var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");

var _forEachInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/for-each");

var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors");

var _Object$defineProperties = require("@babel/runtime-corejs3/core-js-stable/object/define-properties");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _utils = require("../lib/utils");

var _tab = _interopRequireDefault(require("../tab/tab"));

var _constants = require("./constants");

var _pageContext = require("./pageContext");

function _getRequireWildcardCache(nodeInterop) { if (typeof _WeakMap !== "function") return null; var cacheBabelInterop = new _WeakMap(); var cacheNodeInterop = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? _Object$getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { _Object$defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); enumerableOnly && (symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var _context2, _context3; var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? _forEachInstanceProperty(_context2 = ownKeys(Object(source), !0)).call(_context2, function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)) : _forEachInstanceProperty(_context3 = ownKeys(Object(source))).call(_context3, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var PageTabs = /*#__PURE__*/function (_Component) {
  (0, _inherits2["default"])(PageTabs, _Component);

  var _super = _createSuper(PageTabs);

  function PageTabs(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, PageTabs);
    _this = _super.call(this, props);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onTabClick", function (tab) {
      var onTabClick = _this.props.onTabClick;

      if (typeof onTabClick === "function") {
        var _context;

        for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          args[_key - 1] = arguments[_key];
        }

        onTabClick.apply(null, (0, _concat["default"])(_context = [tab]).call(_context, args));
      } else {
        _this.setState({
          activeTabId: tab.id
        });
      }
    });
    _this.state = {
      activeTabId: props.activeTabId || _this.getDefaultActiveTabId()
    };
    return _this;
  }

  (0, _createClass2["default"])(PageTabs, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var setTabPresence = this.context.setTabPresence;
      setTabPresence(true);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var setTabPresence = this.context.setTabPresence;
      setTabPresence(false);
    }
  }, {
    key: "getDefaultActiveTabId",
    value: function getDefaultActiveTabId() {
      var items = this.props.items;
      return items[0] && items[0].id;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          items = _this$props.items,
          tabbar = _this$props.tabbar,
          children = _this$props.children,
          dataTestId = _this$props.dataTestId,
          borderBottom = _this$props.borderBottom,
          variant = _this$props.variant;
      var activeTabId = this.state.activeTabId;
      return (
        /*#__PURE__*/
        // eslint-disable-next-line react/jsx-fragments
        _react["default"].createElement(_react.Fragment, null, /*#__PURE__*/_react["default"].createElement(_tab["default"], {
          dataTestId: dataTestId,
          tabContentTestId: "orion-page-tab-content",
          tabbar: tabbar,
          items: items,
          activeTabId: activeTabId,
          onTabClick: this.onTabClick,
          className: (0, _utils.gatherClasses)(this.props, "oui-page-tabs-container"),
          borderBottom: borderBottom,
          variant: variant
        }), tabbar && /*#__PURE__*/_react["default"].createElement("div", {
          "data-testid": "orion-page-tab-content",
          className: "oui-tab-content oui-with-tabbar"
        }, children))
      );
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props) {
      if (props.activeTabId) {
        return {
          activeTabId: props.activeTabId
        };
      }

      return null;
    }
  }]);
  return PageTabs;
}(_react.Component);

PageTabs.contextType = _pageContext.PageContext;
PageTabs.propTypes = _objectSpread(_objectSpread({}, _tab["default"].propTypes), {}, {
  children: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].node), _propTypes["default"].node]),
  dataTestId: _propTypes["default"].string,
  variant: _propTypes["default"].oneOf(["classic", "default", "widget"])
});
PageTabs.defaultProps = {
  dataTestId: "orion-page-tabs"
};
PageTabs.displayName = _constants.DISPLAY_NAME_TABS;
var _default = PageTabs;
exports["default"] = _default;